import React, { useState } from 'react';
import {
    Box, Typography, Button, TextField, IconButton, InputAdornment,
    Divider, List, ListItem, ListItemIcon, ListItemText, Card, CardContent,
    CircularProgress
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import BusinessIcon from '@mui/icons-material/Business';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { apiFetch, getBaseDomain } from '../api';


const SignupPage = () => {
    const [formData, setFormData] = useState({
        owner_name: '',
        company_name: '',
        subdomain: '',
        email: '',
        password: '',
        plan_name: 'Standard'
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false);

    const handleSignup = async () => {
        setLoading(true);
        try {
            const response = await apiFetch('/register-tenant', {
                method: 'POST',
                body: JSON.stringify(formData)
            });

            const data = await response.json();
            if (response.ok) {
                setIsSuccess(true);
            } else {
                alert('त्रुटी: ' + (data.message || 'नोंदणी अयशस्वी'));
            }
        } catch (error) {
            alert('सर्व्हरशी संपर्क होऊ शकला नाही.');
        }
        setLoading(false);
    };

    return (
        <Box sx={{
            height: '100vh',
            display: 'flex',
            overflow: 'hidden',
            fontFamily: "'Outfit', sans-serif"
        }}>

            {/* LEFT AREA: BRANDING & MARKETING */}
            <Box sx={{
                flex: 1,
                background: 'linear-gradient(135deg, #1B5E20 0%, #083D1B 100%)',
                color: '#fff',
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                justifyContent: 'center',
                px: 8,
                position: 'relative'
            }}>
                {/* SMALL LOGO AT THE VERY TOP */}
                <Box sx={{ position: 'absolute', top: 40, left: 60 }}>
                    <Typography variant="h5" sx={{ fontWeight: 900, letterSpacing: 2, color: '#FFD700', borderBottom: '3px solid #FFD700' }}>
                        CSM PRO
                    </Typography>
                </Box>

                <Box sx={{ mt: 6 }}> {/* Added margin-top to prevent overlap with logo */}
                    <Typography variant="h2" sx={{ fontWeight: 800, mb: 2, lineHeight: 1.1 }}>
                        Centring <br />
                        <span style={{ color: '#FFD700' }}>Supply</span> <br />
                        Management
                    </Typography>

                    <Typography variant="h5" sx={{ mb: 6, opacity: 0.8, fontWeight: 300 }}>
                        तुमचा रेंटल सप्लाय बिझनेस स्मार्ट पद्धतीने मॅनेज करा!
                    </Typography>

                    <List sx={{ maxWidth: 500 }}>
                        {[
                            'साहित्याचे अचूक रेकॉर्ड आणि स्टॉक प्लॅनिंग',
                            'झटपट बिलांची निर्मिती आणि थकीत ट्रॅकिंग',
                            // 'तुमच्या स्वतःच्या सबडोमेनसह प्रोफेशनल ओळख',
                            'सुरक्षित क्लाउड स्टोरेज आणि बॅकअप'
                        ].map((text, index) => (
                            <ListItem key={index} disableGutters sx={{ mb: 1 }}>
                                <ListItemIcon sx={{ minWidth: 40 }}>
                                    <CheckCircleIcon sx={{ color: '#FFD700' }} />
                                </ListItemIcon>
                                <ListItemText primary={text} primaryTypographyProps={{ variant: 'h6', sx: { fontSize: '1.2rem', fontWeight: 400 } }} />
                            </ListItem>
                        ))}
                    </List>
                </Box>

                <Box sx={{ mt: 6, p: 3, borderRadius: 3, backgroundColor: 'rgba(255,255,255,0.1)', display: 'inline-flex', alignItems: 'center', gap: 2 }}>
                    <RocketLaunchIcon sx={{ fontSize: 30, color: '#FFD700' }} />
                    <Typography variant="body1">नोंदणी करा आणि व्यवसाय डिजिटल करा.</Typography>
                </Box>
            </Box>

            {/* RIGHT AREA: SIGNUP FORM OR SUCCESS MESSAGE */}
            <Box sx={{
                width: { xs: '100%', md: '500px' },
                backgroundColor: '#fff',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                p: { xs: 4, md: 6 },
                boxShadow: '-10px 0 30px rgba(0,0,0,0.05)',
                overflowY: 'auto'
            }}>
                {isSuccess ? (
                    <Box sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center'
                    }}>
                        <CheckCircleIcon sx={{ fontSize: 80, color: '#1B5E20', mb: 3 }} />
                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#1B5E20', mb: 2 }}>
                            विनंती प्राप्त झाली!
                        </Typography>
                        <Divider sx={{ width: '60%', my: 2 }} />
                        <Typography variant="h6" sx={{ color: '#102A43', mb: 1, fontWeight: 'bold' }}>
                            तुमचे खाते सध्या 'Pending' आहे.
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#627D98', mb: 4 }}>
                            कृपया खाते अ‍ॅक्टिव्ह करण्यासाठी खालील नंबरवर संपर्क साधा:
                            <br />
                            <Box sx={{
                                mt: 2, p: 2, bgcolor: '#f0fdf4', border: '2px dashed #0FA958',
                                borderRadius: 2, color: '#1B5E20', fontSize: '1.5rem', fontWeight: 900
                            }}>
                                8888888888
                            </Box>
                        </Typography>
                        <Button
                            variant="outlined"
                            color="success"
                            fullWidth
                            onClick={() => window.location.href = '/login'}
                            sx={{ mt: 2, borderRadius: 2, fontWeight: 'bold' }}
                        >
                            लॉगिन पेजवर जा
                        </Button>
                    </Box>
                ) : (
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                            <Box>
                                <Typography variant="h4" sx={{ fontWeight: 800, color: '#102A43', mb: 0.5 }}>नवीन खाते</Typography>
                                <Typography variant="body2" sx={{ color: '#627D98' }}>सप्लाय मॅनेजमेंट सुरू करा</Typography>
                            </Box>
                            <Button
                                variant="outlined" color="success" size="small"
                                sx={{ borderRadius: 2, fontWeight: 'bold' }}
                                onClick={() => window.location.href = '/login'}
                            >
                                Login
                            </Button>
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                            <TextField
                                fullWidth label="तुमचे पूर्ण नाव" variant="filled"
                                onChange={(e) => setFormData({ ...formData, owner_name: e.target.value })}
                                sx={{ '& .MuiFilledInput-root': { backgroundColor: '#f8fafc' } }}
                            />
                            <TextField
                                fullWidth label="कंपनीचे/दुकानचे नाव" variant="filled"
                                onChange={(e) => setFormData({ ...formData, company_name: e.target.value })}
                                sx={{ '& .MuiFilledInput-root': { backgroundColor: '#f8fafc' } }}
                            />
                            <TextField
                                fullWidth label="सबडोमेन निवडा" variant="filled"
                                onChange={(e) => setFormData({ ...formData, subdomain: e.target.value })}
                                placeholder="उदा. amolshop"
                                InputProps={{
                                    endAdornment: <InputAdornment position="end" sx={{ fontWeight: 'bold', color: '#1B5E20' }}>.{getBaseDomain()}</InputAdornment>,
                                }}

                                sx={{ '& .MuiFilledInput-root': { backgroundColor: '#f8fafc' } }}
                            />
                            <TextField
                                fullWidth label="ईमेल आयडी" variant="filled"
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                sx={{ '& .MuiFilledInput-root': { backgroundColor: '#f8fafc' } }}
                            />
                            <TextField
                                fullWidth label="पासवर्ड सेट करा" type={showPassword ? 'text' : 'password'} variant="filled"
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                sx={{ '& .MuiFilledInput-root': { backgroundColor: '#f8fafc' } }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Box>

                        <Divider sx={{ my: 4 }}>प्लॅन निवडा</Divider>

                        <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
                            <Card
                                sx={{
                                    flex: 1, cursor: 'pointer', textAlign: 'center', p: 1,
                                    border: formData.plan_name === 'Standard' ? '2px solid #0FA958' : '1px solid #e2e8f0',
                                    boxShadow: formData.plan_name === 'Standard' ? '0 4px 12px rgba(15,169,88,0.2)' : 'none',
                                    backgroundColor: formData.plan_name === 'Standard' ? '#f0fdf4' : '#fff'
                                }}
                                onClick={() => setFormData({ ...formData, plan_name: 'Standard' })}
                            >
                                <Typography variant="subtitle2" fontWeight="bold">Standard</Typography>
                                <Typography variant="caption" color="textSecondary">सिंगल युजर</Typography>
                            </Card>
                            <Card
                                sx={{
                                    flex: 1, cursor: 'pointer', textAlign: 'center', p: 1,
                                    border: formData.plan_name === 'Pro' ? '2px solid #1B5E20' : '1px solid #e2e8f0',
                                    boxShadow: formData.plan_name === 'Pro' ? '0 4px 12px rgba(27,94,32,0.2)' : 'none',
                                    backgroundColor: formData.plan_name === 'Pro' ? '#ecfdf5' : '#fff'
                                }}
                                onClick={() => setFormData({ ...formData, plan_name: 'Pro' })}
                            >
                                <Typography variant="subtitle2" fontWeight="bold">Pro</Typography>
                                <Typography variant="caption" color="textSecondary">मल्टी युजर</Typography>
                            </Card>
                        </Box>

                        <Button
                            fullWidth variant="contained"
                            size="large" disabled={loading}
                            sx={{
                                py: 2,
                                borderRadius: 2,
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                                backgroundColor: '#1B5E20',
                                '&:hover': { backgroundColor: '#0C3D12' },
                                boxShadow: '0 10px 20px rgba(27,94,32,0.2)'
                            }}
                            onClick={handleSignup}
                            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <BusinessIcon />}
                        >
                            {loading ? 'नोंदणी होत आहे...' : 'सप्लाय मॅनेजमेंट सुरू करा'}
                        </Button>

                        <Box sx={{ mt: 'auto', pt: 4, textAlign: 'center' }}>
                            <Typography variant="body2" sx={{ color: '#627D98' }}>
                                आधीच खाते आहे? <a href="/login" style={{ color: '#1B5E20', textDecoration: 'none', fontWeight: 'bold' }}>येथे लॉगिन करा</a>
                            </Typography>
                        </Box>
                    </>
                )}
            </Box>

        </Box>
    );
};

export default SignupPage;
